/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface MachineUserSettingDto
 */
export interface MachineUserSettingDto {
    /**
     * 
     * @type {number}
     * @memberof MachineUserSettingDto
     */
    machineId: number;
    /**
     * 
     * @type {number}
     * @memberof MachineUserSettingDto
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof MachineUserSettingDto
     */
    userEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof MachineUserSettingDto
     */
    isPendingSelf: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineUserSettingDto
     */
    isPendingOther: boolean;
    /**
     * 
     * @type {string}
     * @memberof MachineUserSettingDto
     */
    pendingOtherEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof MachineUserSettingDto
     */
    isUrgentSelf: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineUserSettingDto
     */
    isUrgentOther: boolean;
    /**
     * 
     * @type {string}
     * @memberof MachineUserSettingDto
     */
    urgentOtherEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof MachineUserSettingDto
     */
    isCriticalSelf: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineUserSettingDto
     */
    isCriticalOther: boolean;
    /**
     * 
     * @type {string}
     * @memberof MachineUserSettingDto
     */
    criticalOtherEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof MachineUserSettingDto
     */
    isSuccessSelf: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineUserSettingDto
     */
    isSuccessOther: boolean;
    /**
     * 
     * @type {string}
     * @memberof MachineUserSettingDto
     */
    successOtherEmail: string;
}

export function MachineUserSettingDtoFromJSON(json: any): MachineUserSettingDto {
    return MachineUserSettingDtoFromJSONTyped(json, false);
}

export function MachineUserSettingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineUserSettingDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'machineId': !exists(json, 'machineId') ? -1 : json['machineId'],
        'userId': !exists(json, 'userId') ? -1 : json['userId'],
        'userEmail': !exists(json, 'userEmail') ? '' : json['userEmail'],
        'isPendingSelf': !exists(json, 'isPendingSelf') ? true : json['isPendingSelf'],
        'isPendingOther': !exists(json, 'isPendingOther') ? false : json['isPendingOther'],
        'pendingOtherEmail': !exists(json, 'pendingOtherEmail') ? '' : json['pendingOtherEmail'],
        'isUrgentSelf': !exists(json, 'isUrgentSelf') ? true : json['isUrgentSelf'],
        'isUrgentOther': !exists(json, 'isUrgentOther') ? false : json['isUrgentOther'],
        'urgentOtherEmail': !exists(json, 'urgentOtherEmail') ? '' : json['urgentOtherEmail'],
        'isCriticalSelf': !exists(json, 'isCriticalSelf') ? true : json['isCriticalSelf'],
        'isCriticalOther': !exists(json, 'isCriticalOther') ? false : json['isCriticalOther'],
        'criticalOtherEmail': !exists(json, 'criticalOtherEmail') ? '' : json['criticalOtherEmail'],
        'isSuccessSelf': !exists(json, 'isSuccessSelf') ? true : json['isSuccessSelf'],
        'isSuccessOther': !exists(json, 'isSuccessOther') ? false : json['isSuccessOther'],
        'successOtherEmail': !exists(json, 'successOtherEmail') ? '' : json['successOtherEmail'],
    };
}

export function MachineUserSettingDtoToJSON(value?: MachineUserSettingDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'machineId': value.machineId,
        'userId': value.userId,
        'userEmail': value.userEmail,
        'isPendingSelf': value.isPendingSelf,
        'isPendingOther': value.isPendingOther,
        'pendingOtherEmail': value.isPendingOther ? value.pendingOtherEmail.trim() : '',
        'isUrgentSelf': value.isUrgentSelf,
        'isUrgentOther': value.isUrgentOther,
        'urgentOtherEmail': value.isUrgentOther ? value.urgentOtherEmail.trim() : '',
        'isCriticalSelf': value.isCriticalSelf,
        'isCriticalOther': value.isCriticalOther,
        'criticalOtherEmail': value.isCriticalOther ? value.criticalOtherEmail.trim() : '',
        'isSuccessSelf': value.isSuccessSelf,
        'isSuccessOther': value.isSuccessOther,
        'successOtherEmail': value.isSuccessOther ? value.successOtherEmail.trim() : '',
    };
}
